<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import { _ } from 'svelte-i18n'

  export let placeholder: string
  export let disabled: boolean
  export let value: string = ''

  const dispatch = createEventDispatcher<{
    'search': () => void,
    'click': () => void,
  }>()

  let isDirtySearch = false

  const clearSearch = () => {
    value = ''
    search()
  }

  const search = () => {
    isDirtySearch = !!value.length
    dispatch('search')
  }

  const inputKeydownHandler = async (e: KeyboardEvent) => {
    if (!value.length) {
      return
    }

    if (e.key === 'Enter') {
      search()
    }
  }
</script> 

<div class="newsline-search">
  {#if disabled}
    <div on:click={() => dispatch('click')}>
      <div class="filter">
        {placeholder}
      </div>

      <div>
        <slot name="icon" />
      </div>
    </div>
  {:else}
    <input 
      bind:value={value}
      type="text"
      {placeholder}
      on:keydown={inputKeydownHandler}
    />

    <div on:click={search}>
      <slot name="icon" isDirtySearch={isDirtySearch} />
      
      {#if isDirtySearch}
        <i 
          class="icon-newsline-search-clear" 
          on:click|stopPropagation={clearSearch} 
        />
      {/if}
    </div>
  {/if}
</div>  

<style lang="scss">
  .newsline-search {
    position: relative;

    input, .filter {
      border: 1px solid #E0E8F6;
      border-radius: 24px;
      width: 100%;
      box-sizing: border-box;
      font-size: 14px;
      
      &:focus {
        outline: none;
      }

      &::placeholder {
        font-size: 14px;
        color: #5A5F6D99;
      }
    }

    .filter {
      color: #5A5F6D99;
      padding: 10px;
      cursor: pointer;
    }

    input {
      color: #22252C;
      padding: 10px 90px 10px 16px;
    }

    :global(i), :global(svg) {
      color: #5A5F6D99;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      cursor: pointer;
    }
  }
</style>